import { CoopCodeComboBoxComponent } from './coop-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { CoopModel } from './coop.model';

/**
 * 会員生協コンボボックスモデル
 *
 * @export CoopCodeComboBoxModel
 * @class CoopCodeComboBoxModel
 */
export class CoopCodeComboBoxModel {

  // 会員生協情報リスト
  public coopList: CoopModel[];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // 先頭全生協表示
  public allCoop: boolean = <boolean>false;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setCoopCode: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;

  public component: CoopCodeComboBoxComponent;                                  // コンボボックスインスタンス

  /**
   * 会員生協情報を更新する
   *
   * @param {*} serverData 会員生協情報リスト取得データ
   * @returns {void}
   * @memberof CoopCodeComboBoxModel
   */
  public updateCoopList(serverData: CoopModel[]): void {
    let tempDataList: CoopModel[] = [];

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = [];
      }
    }

    // 処理件数
    let index: number = <number>0;

    // コード+：+名称追加
    tempDataList.forEach(item => item.CoopCodeName = item.CoopCode + ':' + item.CoopName);

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankCoopObject('', ''));
      index = 1;
    }
    // 全生協
    if (this.allCoop) {
      tempDataList.splice(index, 0, this.getBlankCoopObject('*', '全生協'));
      index += 1;
    }

    this.coopList = tempDataList;

    this.completeUpdateFlg = true;
    this.component.updateSelectedCoopCode();
  }

  /**
   * 空白の会員生協オブジェクトを取得する
   *
   * @private
   * @param {string} coopCode 生協コード
   * @param {string} coopName 生協名
   * @returns {CoopModel} 会員生協オブジェクト
   * @memberof CoopCodeComboBoxModel
   */
  private getBlankCoopObject(coopCode: string, coopName: string): CoopModel {
    const ob = new CoopModel();
    ob.CoopCode = coopCode;
    ob.CoopName = coopName;
    ob.PlanCoopName = '';
    ob.CoopShortName = '';
    ob.CoopCodeName = '';
    if (!PlessViewUtilsSub.isEmpty(coopCode)) {
      ob.CoopCodeName = coopCode + ':' + coopName;
    }

    return ob;
  }

}
